<template>
  <div class="telhflstj text_center">
    <sec-title Text="合肥律师推荐" />
    <div class="tel_hftj_cont between wrap">
      <div class="item" v-for="(item, index) in 6" :key="index">
        <div class="flex" v-if="index % 2 == 0">
          <div class="fmcov">
            <img src="../../../assets/telzx/laydefault.png" class="cover" />
            <div class="telzxbtn center">
              <svg-icon icon-class="dianhua" /> <span>电话咨询</span>
            </div>
          </div>
          <div class="info">
            <div class="name ellipsis">法律咨询</div>
            <div class="defa_dec">
              {{ `绝对隐私、安全` | toEllipsisFilter(30) }}
            </div>
            <div class="sertime">服务时间：9:00 - 20:00</div>
            <div class="num between">
              <div class="ser">服务人数：10000</div>
              <div>好评数：10000</div>
            </div>
            <div class="defa_zx">在线咨询</div>
          </div>
        </div>
        <div class="flex" v-if="index % 2 == 1">
          <div class="fmcov">
            <img
              src="../../../assets/home/lvshi_lv_sample1.png"
              class="cover"
            />
            <div class="telzxbtn center">
              <svg-icon icon-class="dianhua" /> <span>电话咨询</span>
            </div>
          </div>
          <div class="info">
            <div class="name ellipsis">李XX律师</div>
            <div class="ad ellipsis">安徽xxxxxx律师事务所</div>
            <div class="dec">
              {{
                `介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介`
                  | toEllipsisFilter(35)
              }}
            </div>
            <div class="sertime">服务时间：9:00 - 20:00</div>
            <div class="num between">
              <div class="ser">服务人数：10000</div>
              <div>好评数：10000</div>
            </div>
            <div class="price"><span>¥99</span>/20分钟</div>
          </div>
        </div>
      </div>
    </div>
	<div class="show_how flex-col ">
		<div class="title FontSize20 FontGray">
			哪些情况适合电话咨询
		</div>
		<ul class="howlist flex between">
			<li class="flex center">
				<img src="../../../assets/telzx/icon1.png" >
				<div class="flex-col">
					<span class="FontSize18">问题比较多</span>
					<span class="FontSize12 FontGray">需要与律师沟通清楚</span>
				</div>
			</li>
			<li class="flex center">
				<img src="../../../assets/telzx/icon1.png" >
				<div class="flex-col">
					<span class="FontSize18">问题比较多</span>
					<span class="FontSize12 FontGray">需要与律师沟通清楚</span>
				</div>
			</li>
			<li class="flex center">
				<img src="../../../assets/telzx/icon1.png" >
				<div class="flex-col">
					<span class="FontSize18">问题比较多</span>
					<span class="FontSize12 FontGray">需要与律师沟通清楚</span>
				</div>
			</li>
			<li class="flex center">
				<img src="../../../assets/telzx/icon1.png" >
				<div class="flex-col">
					<span class="FontSize18">问题比较多</span>
					<span class="FontSize12 FontGray">需要与律师沟通清楚</span>
				</div>
			</li>
		</ul>
	</div>
	
    <!-- <div class="tel_hftj_cont2 between">
      <div class="tjls">
        <sub-title text="推荐律师" />
        <div class="tjlist between">
          <div class="item between" v-for="(item,index) in 3" :key="index">
            <div class="tj_cover">
              <img src="../../../assets/telzx/aaaa1_sample.png" />
            </div>
            <div class="tj_info">
              <div class="tj_name">李XX律师</div>
              <div class="tj_ser">服务人数：1000人</div>
              <div class="tj_tel_btn center">电话咨询</div>
            </div>
          </div>
        </div>
      </div>
      <div class="ys"><img src="../../../assets/telzx/ys.png" alt="" /></div>
    </div> -->
  </div>
</template>

<script>
import secTitle from "../../home/components/secTitle";
import subTitle from "../../home/components/subTitle";
export default {
  components: {
    secTitle,
    subTitle,
  },
};
</script>

<style lang="scss" scope>
.telhflstj {
  width: 1200px;
  padding: 50px 0;
  margin: 0 auto;
  .tel_hftj_cont {
    box-shadow: 0px 0px 0 1px #e8e8e8;
    margin-top: 30px;
    .item {
      width: 400px;
      height: 248px;
      padding: 10px;
      &:hover {
        box-shadow: 0px 0px 10px 0px rgba(38, 38, 38, 0.08);
        .fmcov .telzxbtn {
          color: #fff;
          background: #0465ea;
        }
      }
      .fmcov {
        .cover {
          width: 130px;
          height: 164px;
        }
        .telzxbtn {
          cursor: pointer;
          width: 98px;
          height: 30px;
          margin: 16px auto;

          color: #0465ea;
          background: #fff;
          border: 1px solid #0465ea;

          border-radius: 15px;
          font-size: 16px;
          span {
            font-size: 14px;
            margin-left: 2px;
          }
        }
      }
      .info {
        width: 234px;
        text-align: left;
        font-size: 14px;
        line-height: 14px;
        margin-left: 16px;
        color: #666666;
        .name {
          font-size: 18px;
          color: #333333;
          line-height: 18px;
          margin-top: 12px;
        }
        .defa_dec {
          margin-top: 15px;
          margin-bottom: 20px;
        }
        .defa_zx {
          margin-top: 30px;
        }
        .ad {
          margin: 12px 0 8px;
        }
        .dec {
          font-size: 12px;
          color: #999999;
          line-height: 20px;
          margin-bottom: 14px;
        }
        .num {
          margin: 10px 0;
          .ser {
            border-right: 1px solid #b2b2b2;
            width: 133px;
            line-height: 16px;
          }
        }
        .price {
          font-weight: bold;
          span {
            color: #ff6600;
          }
        }
      }
    }
  }
  .show_how{
	  .title{
		  position: relative;
		  padding: 50px 0;
	  }
	  li{
		  width: 280px;
		  height: 88px;
		  background: #FAFAFA;
		  text-align: left;
		  img{
			  margin-right: 15px;
		  }
	  }
	 .title::before{
		 content: "———";
	 }
	 .title::after{
		 content: "———";
	 }
  }
  .tel_hftj_cont2 {
    height: 190px;
    margin-top: 30px;
    .tjls {
      width: 816px;
      height: 100%;
      .tjlist {
        .item {
          margin-top: 30px;
          width: 260px;
          height: 140px;
          padding: 0 14px;
          background-color: #fff;
          box-shadow: 0px 0px 10px 0px rgba(38, 38, 38, 0.08);
          &:hover {
            .tj_info .tj_tel_btn {
              color: #ffffff;
              background: #0465ea;
            }
          }
          .tj_cover {
            width: 85px;
            height: 85px;
            border-radius: 50%;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .tj_info {
            text-align: left;
            .tj_name {
              font-size: 18px;
              font-weight: bold;
              color: #333333;
            }
            .tj_ser {
              font-size: 16px;
              color: #666;
              margin: 10px 0;
            }
            .tj_tel_btn {
              width: 90px;
              height: 26px;
              background: #ffffff;
              border: 1px solid #0465ea;
              font-size: 14px;
              color: #0465ea;
              cursor: pointer;
            }
          }
        }
      }
    }
    .ys {
      img {
        width: 354px;
        height: 190px;
      }
    }
  }
}
</style>
